var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4967 14V12.6667C13.4967 11.9594 13.2157 11.2811 12.7156 10.781C12.2155 10.281 11.5372 10 10.83 10H6.83C6.12275 10 5.44448 10.281 4.94438 10.781C4.44428 11.2811 4.16333 11.9594 4.16333 12.6667V14",
    stroke: "#E17954",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83 7.33333C10.3028 7.33333 11.4967 6.13943 11.4967 4.66667C11.4967 3.19391 10.3028 2 8.83 2C7.35724 2 6.16333 3.19391 6.16333 4.66667C6.16333 6.13943 7.35724 7.33333 8.83 7.33333Z",
    stroke: "#E17954",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.5b536225e1a3a6acd5c530a197656bf8.svg";
export { ForwardRef as ReactComponent };